<template>
  <el-dialog
    :title="form.confirmType == 1 ? '订单开票二次确认' : '订单红冲二次确认'"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :append-to-body="true"
    width="500px"
    @close="close"
  >
    <el-form ref="confirmForm" :model="form" label-width="100px" size="small" :rules="rules">
      <div class="flex flex-center margin-bottom-20 color-redFont">
        {{
          form.confirmType == 1
            ? '确认后开票信息状态将改为开票【开票成功】'
            : '确认后红冲信息状态将改为红冲【开具成功】'
        }}
      </div>

      <!-- 发票号码 -->
      <el-form-item label="发票号码" prop="invoiceNo" v-if="form.confirmType == 1">
        <el-input
          v-model="form.invoiceNo"
          placeholder="请输入20位数字发票号码"
          maxlength="20"
          @input="validateInvoiceNumber"
          show-word-limit
        />
      </el-form-item>

      <el-form-item label="上传pdf" v-if="form.confirmType == 1">
        <FileUpload
          ref="upload"
          @input="uploadSuccess"
          :list="form.fileList"
          accept=".pdf"
          code="work-order"
          :fileSize="2"
          :limit="1"
        />
      </el-form-item>

      <!-- 反馈信息 -->
      <el-form-item label="反馈信息">
        <el-input
          v-model="form.feedback"
          type="textarea"
          :rows="3"
          placeholder="请输入反馈信息（最多100字）"
          maxlength="100"
          show-word-limit
        />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="close">关闭</el-button>
      <el-button type="primary" size="small" @click="confirm" :loading="loading">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { confirmInvoiceAction } from '@/api/invoice'
  import FileUpload from '@/components/FileUpload'
  export default {
    name: 'InvoiceAction',
    components: {
      FileUpload
    },
    data() {
      return {
        loading: false,
        form: {
          invoiceNo: '',
          fileList: [],
          confirmType: '' // 1为邮件开票二次确认，2为红冲二次确认
        },
        rules: {
          invoiceNo: [{ validator: this.validateInvoiceNumberLength, trigger: 'blur' }]
        },
        dialogVisible: false
      }
    },
    methods: {
      /**
       * 验证发票号码只能输入数字
       */
      validateInvoiceNumber(value) {
        // 移除非数字字符
        this.form.invoiceNo = value.replace(/[^\d]/g, '')
      },

      /**
       * 验证发票号码长度规则
       */
      validateInvoiceNumberLength(rule, value, callback) {
        if (value && value.length < 20) {
          callback(new Error('发票号码长度不足20位，请检查'))
        } else {
          callback()
        }
      },
      // 文件上传成功
      uploadSuccess(list) {
        this.form.fileList = list
      },
      /**
       * 关闭弹窗
       */
      close() {
        this.dialogVisible = false
        this.resetForm()
      },

      /**
       * 确认操作
       */
      confirm() {
        // 触发表单验证
        this.$refs.confirmForm.validate((valid) => {
          if (valid) {
            this.loading = true

            const { fileList } = this.form

            const data = {
              ...this.form,
              pdfFileUrl: fileList.map((item) => item.url).join(',')
            }

            confirmInvoiceAction(data).then((res) => {
              if (res.code === 0) {
                this.$message({
                  message: '确认成功',
                  type: 'success'
                })

                this.$emit('refresh')
                this.close()
              }
              this.loading = false
            })
          }
        })
      },

      /**
       * 重置表单
       */
      resetForm() {
        this.form = {
          fileList: []
        }
        this.$nextTick(() => {
          this.$refs.confirmForm && this.$refs.confirmForm.resetFields()
        })
      },
      /**
       * 打开弹窗
       */
      open(batchNumber, confirmType) {
        this.form.batchNumber = batchNumber
        this.form.confirmType = confirmType
        this.dialogVisible = true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .dialog-footer {
    text-align: right;
  }
</style>
